/**
 * @fileoverview This file simply re-exports the Turf.js library so that we can
 * import it without using the `import * ...` syntax.
 */

import * as turf from "@turf/turf";
export default turf;
